import React, { useContext, useEffect, useState } from "react";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, apiSuccessToast } from "../utils/ToastUtil";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import AuthContext from "../store/AuthContext";
import BillDetailsModal from "../modals/BillDetailsModal";
import Loader from "../component/loading-screen/Loader";

const PartPaymentElectricity = () => {
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState([]);
  const [billerName, setBillerName] = useState("");
  const [formData, setFormData] = useState({});
  const [progress, setProgress] = useState(false);
  const [fetchMandatory, setFetchMandatory] = useState("");
  const [billerId, setBillerId] = useState("TATAPWR00DEL01");
  const [amountValue, setAmountValue] = useState("");
  const [directPay, setDirectPay] = useState(false);
  const [billDetails, setBillDetails] = useState(false);
  const [mpinVal, setMpinVal] = useState(false);
  const [billValue, setBillValue] = useState();
  const [currentBiller, setCurrentBiller] = useState(false);
  const authCtx = useContext(AuthContext);

  const location = authCtx.location;

  const getBillersDetails = () => {
    setLoading(true);

    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS_DETAILS,
      { billerId: "TATAPWR00DEL01" },
      setLoading,
      (res) => {
        const data = res.data?.data || {};
        setFetchMandatory(data.fetchRequirement);
        setDirectPay(false);
        setAmountValue("");
        let updatedParams = data.parameters || [];

        if (!updatedParams.some((param) => param.desc === "Mobile Number")) {
          updatedParams.push({
            name: "param2",
            desc: "Mobile Number",
            minLength: 10,
            maxLength: 10,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[6-9]d{9}$",
          });
        }

        setParams(updatedParams);
        setBillerName(data.billerInfo?.name || "");
        setLoading(false);
      },
      (err) => {
        apiErrorToast(err);
        setLoading(false);
      }
    );
  };
  const fetchBill = () => {
    const data = {
      billerId: billerId,
      latitude: location.lat,
      longitude: location.long,
      amount: 0,
    };

    params.forEach((item) => {
      data[item.name] = formData[item.name] || "";
    });

    const hasEmptyField = params.some(
      (item) => item.mandatory === 1 && !formData[item.name]
    );

    if (hasEmptyField) {
      apiErrorToast("Please fill out all the mandatory fields");
      return;
    }

    postJsonData(
      ApiEndpoints.BBPS_FETCH_BILL,
      data,
      setProgress,
      (res) => {
        setBillDetails(res.data.data.data);
        setAmountValue("");
      },
      (err) => {
        setDirectPay(true);
        apiErrorToast(err);
      }
    );
  };

  useEffect(() => {
    getBillersDetails();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#F7F4EF",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 500,
          borderRadius: "16px",
          bgcolor: "white",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#D48628", mb: 2 }}
        >
          Electricity Payment
        </Typography>

        <Box display="flex" justifyContent="center" my={2}>
          <Loader loading={progress} />
        </Box>

        <>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Select value={billerName} displayEmpty>
              <MenuItem value="" disabled>
                Select Provider
              </MenuItem>
              <MenuItem value={billerName}>{billerName}</MenuItem>
            </Select>
          </FormControl>

          <Grid container spacing={2}>
            {params.map((item, index) => (
              <Grid item xs={12} key={index}>
                <TextField
                  label={item.desc}
                  id={item.name}
                  inputProps={{
                    minLength: item.minLength,
                    maxLength: item.maxLength,
                    pattern: item.regex,
                  }}
                  size="small"
                  required={item.mandatory === 1}
                  type={item.inputType === "NUMERIC" ? "number" : "text"}
                  value={formData[item.name] || ""}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
            ))}
            {directPay && (
              <Grid item xs={12}>
                <FormControl
                  sx={{
                    width: "100%",
                    mr: "19%",
                  }}
                >
                  <TextField
                    label="Amount"
                    id="amount"
                    //  size="small"
                    sx={{
                      "& .MuiInputBase-input": {
                        fontSize: "12px",
                        color: "black",
                      },
                      "& .MuiInputBase-input::placeholder": {
                        fontSize: "12px",
                        opacity: 1,
                      },
                    }}
                    value={amountValue}
                    onChange={(e) => {
                      setAmountValue(e.target.value);
                    }}
                    required
                  />
                </FormControl>
              </Grid>
            )}
            <Grid item md={12} xs={12}>
              <FormControl sx={{ mt: 2, width: "100%" }}>
                {fetchMandatory === "MANDATORY" ? (
                  <BillDetailsModal
                    billvaluePan={true}
                    billerId={billerId}
                    directPay={directPay}
                    setDirectPay={setDirectPay}
                    params={params}
                    currentBiller={currentBiller}
                    billDetails={billDetails}
                    setBillDetails={setBillDetails}
                    fetchBill={fetchBill}
                    billValue={billValue}
                    setBillValue={setBillValue}
                    amountValue={amountValue}
                    
                    view={"partpayment"}
                  />
                ) : (
                  <Button
                    type="submit"
                    form="bbpsForm"
                    className="btn-background"
                    sx={{ width: "100%", mt: 1 }}
                  >
                    {mpinVal ? "Pay Now" : "Continue"}
                  </Button>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </>
      </Box>
    </Box>
  );
};

export default PartPaymentElectricity;
